import { Loader2, LogIn } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import {
  FIELD_CLASS_BOLD_DISABLABLE as FIELD_CLASS,
  LABEL_CLASS_LOOSE as LABEL_CLASS,
} from '../components/common/form.styles';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';

export function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const { login } = useAuth();
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();

    if (!username || !password) {
      toast.error('Vui lòng nhập đủ tên đăng nhập và mật khẩu.');
      return;
    }

    setSubmitting(true);
    try {
      const user = await login(username, password);
      navigate(`/${user.role.toLowerCase()}`, { replace: true });
    } catch {
      // Toast lỗi do interceptor bắn; ở đây chỉ mở khoá lại nút.
      setSubmitting(false);
    }
  };

  return (
    <div className="bg-canvas relative flex min-h-screen items-center justify-center overflow-hidden p-4 font-sans">
      {/* Vệt sáng nền — thuần trang trí */}
      <div className="bg-accent/5 absolute left-1/4 top-1/4 h-[400px] w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-full blur-[100px]" />
      <div className="bg-success/5 absolute bottom-1/4 right-1/4 h-[450px] w-[450px] translate-x-1/2 translate-y-1/2 rounded-full blur-[120px]" />

      <div className="border-line bg-panel relative w-full max-w-md overflow-hidden rounded-xl border shadow-[0_20px_50px_-12px_rgba(0,0,0,0.5)]">
        <div className="flex flex-col items-center px-6 pb-2 pt-8">
          <div className="border-accent-border bg-accent-soft flex h-14 w-14 items-center justify-center rounded-xl border">
            <LogIn size={24} className="text-accent" />
          </div>
          <h1 className="text-ink mt-5 text-[20px] font-bold">Chào mừng trở lại</h1>
          <p className="text-ink-dim mt-1.5 text-[13px]">Đăng nhập để vào bảng điều khiển</p>
        </div>

        <form
          onSubmit={(event) => {
            void handleSubmit(event);
          }}
          className="space-y-4 px-6 pb-6 pt-6"
        >
          <div>
            <label htmlFor="username" className={LABEL_CLASS}>
              Tên đăng nhập
            </label>
            <input
              id="username"
              type="text"
              autoComplete="username"
              value={username}
              onChange={(e) => {
                setUsername(e.target.value);
              }}
              disabled={submitting}
              className={FIELD_CLASS}
              placeholder="Nhập tên đăng nhập"
            />
          </div>

          <div>
            <label htmlFor="password" className={LABEL_CLASS}>
              Mật khẩu
            </label>
            <input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
              }}
              disabled={submitting}
              className={FIELD_CLASS}
              placeholder="Nhập mật khẩu"
            />
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="bg-accent hover:bg-accent-hover disabled:bg-panel-hover disabled:text-ink-ghost flex w-full items-center justify-center gap-2 rounded-lg border-none px-4 py-3 text-[14px] font-semibold text-white transition-colors focus:outline-none disabled:cursor-not-allowed"
          >
            {submitting ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                Đang đăng nhập...
              </>
            ) : (
              <>
                <LogIn size={16} />
                Đăng nhập
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
